import { render, staticRenderFns } from "./MonoTwitterIcon.vue?vue&type=template&id=2041cfe0&scoped=true"
import script from "./MonoTwitterIcon.vue?vue&type=script&lang=js"
export * from "./MonoTwitterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041cfe0",
  null
  
)

export default component.exports